'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconRectangleCheckLines, iconRectangleCheckLinesTag } from '@ni/nimble-components/dist/esm/icons/rectangle-check-lines';
import { wrap } from '../../utilities/react-wrapper';

export type { IconRectangleCheckLines };
export { iconRectangleCheckLinesTag };
export const NimbleIconRectangleCheckLines = wrap(IconRectangleCheckLines);